import React from 'react';
import cvData from '../../data/cv';
import { Rubric } from './Rubric';
import { CompanyMark } from './CompanyMark';
import { ChipRow } from './TechStack';
const {
  summary,
  skills,
  education,
  meta
} = cvData;
/** Profile prose — sits in the intro band. */
export function ProfileBlock({
  compact = false
}: {
  compact?: boolean;
}) {
  const paras = compact ? summary.slice(0, 2) : summary;
  return <section data-id="element-17" data-mp="1ijfsu1657nxb">
      <Rubric index={meta.sections.profile.index} title={meta.sections.profile.title} data-id="element-18" data-mp="1ij656k8klsus" />
      <div className="space-y-3" data-id="element-19" data-mp="1ehazl3jlwtb7">
        {paras.map((p, i) => <p key={i} className={i === 0 ? 'text-[13px] leading-relaxed text-[var(--ink)]' : 'text-[12px] leading-relaxed text-[var(--ink-soft)]'} data-id="element-20" data-mp="1s9hfcoiukya4" data-mpi={i}>
            {p}
          </p>)}
      </div>
    </section>;
}
/** Capability index — sits in the intro band. */
export function CapabilitiesBlock() {
  return <section data-id="element-21" data-mp="18jk2eqzghjuz">
      <Rubric index={meta.sections.capabilities.index} title={meta.sections.capabilities.title} count={`${skills.length} groups`} data-id="element-22" data-mp="18jtt6gsbrv1q" />
      <dl className="divide-y divide-[var(--line)]" data-id="element-23" data-mp="1hjgnyjqju2lt">
        {skills.map(group => <div key={group.label} className="avoid-break py-3 first:pt-0" data-id="element-24" data-mp="1hlt8n4noyr2k">
            <dt className="mb-2 font-mono text-[9.5px] uppercase tracking-[0.2em] text-[var(--accent)]" data-id="element-25" data-mp="1mjuwe2w2bekd">
              {group.label}
            </dt>
            <dd data-id="element-26" data-mp="1wg7k8k4xey77">
              <ChipRow labels={group.items} data-id="element-27" data-mp="1wfpij7zhvrrw" />
            </dd>
          </div>)}
      </dl>
    </section>;
}
/** Education — laid out horizontally. */
export function EducationBlock() {
  return <section data-id="element-28" data-mp="257rf2v6g0nww">
      <Rubric index={meta.sections.education.index} title={meta.sections.education.title} data-id="element-29" data-mp="258je6fz913rx" />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-30" data-mp="2a61bf93wluk3">
        {education.map((edu, i) => <div key={i} className="cv-entry flex items-start gap-3.5" data-id="element-31" data-mp="2f54j71b9qevr" data-mpi={i}>
            <CompanyMark company={edu.school} mark={edu.mark} domain={edu.domain} data-id="element-32" data-mp="f5r5yyog2uzo" />
            <div className="min-w-0" data-id="element-33" data-mp="a41szdhnw78y">
              {edu.period && <span className="font-mono text-[11px] tabular-nums text-[var(--ink-faint)]" data-id="element-34" data-mp="owdhoht1j1d3">
                  {edu.period}
                </span>}
              <h3 className="font-display text-[15px] font-medium leading-snug text-[var(--ink)]" data-id="element-35" data-mp="xupex2oewxei">
                {edu.degree}
              </h3>
              <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-[0.06em] text-[var(--accent)]" data-id="element-36" data-mp="tvydwkgtsvm4">
                {edu.school}
              </p>
              {edu.note && <p className="mt-1 text-[11px] leading-relaxed text-[var(--ink-soft)]" data-id="element-37" data-mp="12vd2tfhcgy4i">
                  {edu.note}
                </p>}
            </div>
          </div>)}
      </div>
    </section>;
}